import { LoadDetailPlatform } from "../domain/LoadDetailPlatform.model";
import { LoadDetailPlatformApiModel } from "../infrastructure/models/load-detail-platform-api.model";

export function SetMapLoadDetailPlatforms(
    loadDetailPlatforms: LoadDetailPlatformApiModel[]
): LoadDetailPlatform[] {
    return loadDetailPlatforms.map(SetMapLoadDetailPlatform);
}

export function SetMapLoadDetailPlatform(
    loadDetailPlatform: LoadDetailPlatformApiModel
): LoadDetailPlatform {
    const {
        ID,
        CreatedAt,
        UpdatedAt,
        DeletedAt,
        activityPlatformId,
        frontExtensions,
        backExtensions,
        distanceValidations,
        mooringsValidations,
        securedRampsValidations,
        guardedKeysValidations,
        createdBy,
        updatedBy,
        ...rest
    } = loadDetailPlatform;

    return {
        id: ID,
        createdAt: CreatedAt,
        updatedAt: UpdatedAt,
        deletedAt: DeletedAt,
        activityPlatformId: activityPlatformId,
        frontExtensions: frontExtensions,
        backExtensions: backExtensions,
        distanceValidations: distanceValidations,
        mooringsValidations: mooringsValidations,
        securedRampsValidations: securedRampsValidations,
        guardedKeysValidations: guardedKeysValidations,
        createdBy: createdBy,
        updatedBy: updatedBy,
        ...rest
    };
}